module.exports = __webpack_public_path__ + "img/lorry_wide_banner.2e6e5a16.jpg";